module.exports = __webpack_public_path__ + "static/media/coding-lesson-for-kids.c0062209.jpg";